(ns app.front.ui.sortable
  (:require [app.front.ui.dnd :as dnd]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [reagent.core :as r]))

(defn draggable-list-item [{:keys [on-remove tr opts]} content]
  [:span.px-3.py-2.font-bold.text-xs.text-center.rounded-md.mr-2.border-2.border-solid.border-ui-violet-50.whitespace-nowrap.inline-block.my-1.cursor-pointer
   opts
   (cc/icon {:icon        i/draggable
             :height      "10px"
             :description (tr [:draggable])
             :class-name  "cursor-pointer pr-2"})
   content
   [:button.bg-transparent.border-0 {:type     :button
                                     :on-click on-remove}
    (cc/icon {:icon        i/remove
              :height      "10px"
              :description (tr [:remove])
              :class-name  "cursor-pointer pl-2"})]])

(defn add-cancel-buttons [{:keys [tr on-add on-cancel disabled?]}]
  [:<>
   (cc/button {:kind             :ghost
               :icon-position    :right
               :icon-description (tr [:cancel])
               :class-name       "only-icon-button"
               :size             :field
               :icon             i/remove
               :on-click         on-cancel}
              "")
   (cc/button {:kind             :ghost
               :icon-position    :right
               :icon-description (tr [:add])
               :class-name       "only-icon-button"
               :size             :field
               :icon             i/check
               :disabled         disabled?
               :on-click         on-add}
              "")])

(defn add-component [{:keys [id available-values val->str add-item add-button-text tr]}]
  (r/with-let [*select (r/atom {:selecting? false})]
    (when available-values
      (if (:selecting? @*select)
        [:div.flex.max-w-xl
         [ui-select/select (util/mmap {:id           (str id "-select")
                                       :class-name   "full-width-select"
                                       :allow-empty? false
                                       :value        (:value @*select)
                                       :on-change    (fn [value]
                                                       (swap! *select assoc :value value))
                                       :values       available-values}
                                      val->str)]
         [add-cancel-buttons
          (util/mmap {:on-add    (fn [_]
                                   (add-item (:value @*select))
                                   (reset! *select {:selecting? false}))
                      :on-cancel (fn [_]
                                   (swap! *select assoc :selecting? false))
                      :disabled? (-> @*select :value nil?)}
                     tr)]]
        [:div.flex-initial.mt-2
         (cc/button {:size     :field
                     :icon     i/plus
                     :kind     :primary
                     :on-click #(swap! *select assoc :selecting? true)}
                    (or add-button-text (tr [:add])))]))))

(defn sortable-items [{:keys [add-button-text
                              selected
                              values
                              val->str
                              remove-item
                              add-item
                              tr
                              id
                              on-reorder
                              on-order-changed]}]
  [:div
   [dnd/wrap-dnd
    (p/assoc-if
      {:id                  (str id "-sortable-dnd")
       :items               selected
       :props-for-source    {:class "bg-ui-blue-10 translate-x-2"}
       :always-show-handle? true}
      :on-reorder       (if on-order-changed
                          (dnd/wrap-on-order-changed selected on-order-changed)
                          on-reorder))
    (fn [{:keys [sorted augment-draggable-props augment-target-props]}]
      (futil/for-frag-indexed [[idx item] sorted]
        [draggable-list-item
         {:id        idx
          :tr        tr
          :on-remove #(remove-item idx)
          :opts      (-> {:class "transform ease-in-out duration-100 cursor-pointer"}
                         (augment-draggable-props item)
                         (augment-target-props item))}
         (val->str item)]))]
   [add-component (util/mmap {:available-values (seq values)}
                             id val->str add-item add-button-text tr)]])
